import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

const defaultId = 'defaultLoader';
const loaderSubject = new Subject();

export const loaderService = {
    onLoader,
    loader,
    clear,
    showLoader
};


function onLoader(id = defaultId) {
    return loaderSubject.asObservable().pipe(filter(x => x && x.id === id));
}

function showLoader({ id, size = "sm", label = "Cargando..." }) {
    loader({ id, size, label });
}

function loader(loader) {
    loader.id = loader.id || defaultId;
    loaderSubject.next(loader);
}

function clear(id = defaultId) {
    loaderSubject.next({id});
}
